module.exports = __webpack_public_path__ + "static/img/w-5.f2c2174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-5.jpg
// module id = QO82
// module chunks = 1